import styled, { css } from 'styled-components';

import { inlineMediaQueryMixin, mediaMixin, PageContent, spaceMixin, token } from '@zillow/constellation';

const displayCSS = (mediaProps: { display: string }) => css`
  display: ${mediaProps.display};
`;

export const StyledContentContainer = styled(PageContent)<{ maxWidth: string | number }>`
  && {
    padding: ${spaceMixin('sm')};
    width: 100%;
    ${({ maxWidth }) => (maxWidth ? `max-width: ${maxWidth}px` : '')};
    box-sizing: border-box;
    margin: 0;
  }
`;

export const StyledDisplayContainer = styled.div<{ display: { default?: string; md?: string; xxl_gte?: string } }>`
  ${inlineMediaQueryMixin('display', displayCSS)}
`;

export const StyledTextAlignCenter = styled.div`
  text-align: center;
`;

export const StyledBg = styled.div<{ isFluidBg: boolean; backgroundColor: string }>`
  ${({ isFluidBg }) =>
    isFluidBg &&
    css`
      display: flex;
      justify-content: center;

      position: relative;
      left: 50%;
      width: 100vw;
      transform: translateX(-50%);
    `}

  background-color: ${({ backgroundColor }) => backgroundColor && token(`colors[${backgroundColor}]`)}
`;

export const StyledBgFullWidth = styled.div`
  ${mediaMixin(
    'xl_lte',
    css`
      width: 90%;
      margin: auto;
    `,
  )}

  // need full-width on large screens to accommodate comparison chart content
  @media (min-width: 1440px) {
    width: 100vw;
  }
`;
